import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Typography } from "components/controls/widget";

interface GroupProps {
    title: string;
}

class Group extends React.PureComponent<GroupProps & WithStyles<typeof styles>> {

    render() {
        const { title, classes, children } = this.props;
        return <div>
            <Typography className={classes.title} variant="h6">{title}</Typography>
            <div className={classes.container}>{children}</div>
        </div>;
    }
}


export const styles = (theme: Theme) => createStyles({
    title: {
        borderBottom: `1px solid ${theme.palette.primary.light}`,
        marginBottom: theme.spacing.unit * 2,
    },
    container: {
        padding: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(Group);